"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLES = void 0;
const uniq_1 = __importDefault(require("lodash/uniq"));
const REGIONAL_MANAGER_PERMISSIONS = [
    "Pin_Myself:Read",
    "User_Driver_CanSpeakEnglish:Update",
    "DynamicFormConfig:Read",
    "DriverVat:Validate",
    "AssignationOffersPage:Read",
    "Unavailability:Read",
    "DriversPage:Read",
    "CompaniesPage:Read",
    "DriversMapPage:Read",
    "CompanyDriversPage:Read",
    "MangopayInformation:Read",
    "BillingInformationPage:Read",
    "BillingInformation:Modify",
    "User_Driver:Create",
    "User_Driver:Update",
    "User_Driver_RM:Modify",
    "DriversCompany:Read",
    "DriversCompanies:Read",
    "DriversCompany:Modify",
    "DriverVehicle:Update",
    "DriverVehicle:Approve",
    "DriverBalance:Read",
    "DriverCustomerFeedback:Read",
    "DriversFeedbacksPage:Read",
    "DriverDocument:Modify",
    "DriverVehicleDocument:Modify",
    "DriverDocument:Approve",
    "Drivers:Read",
    "DriverAssignations:Read",
    "CooperationAgreementSignPage:Read",
    "UserInvoicingData:Read",
    "Vehicle:Create",
    "Vehicle:ReadAllowOld",
    "DriverProfilePage:Read",
    "DriverVehiclesPage:Read",
    "PasswordResetPage:Read",
    "VehicleModel:Read",
    "OrderInAssignedCountries:Read", // needed on the driver feedback page (it loads the orders to read feedback for)
    "ComboAssignationPage:Read",
    // read only to orders and order details page - we might need to add it soon to RMs
    // "OrdersPage:Read",
    // "Orders:Read",
    // "OrderClaims:Read",
    // "Payments:Read",
    // "Chargebacks:Read",
    "EarlyOfferCredit:Read",
    "TripStatus:Read",
    "TripTracking:Read",
    "DriverTrackingLocations:Read",
    "DriverFaq:ReadAll",
    "DriverTermsAndConditions:Read",
    "DriverTermsAndConditionsPage:Read",
];
const FINANCE_ROLE_PERMISSIONS = [
    "InternalManagement:Access",
    "Fresh",
    "ContentCountriesPage:Read",
    "ContentCurrenciesPage:Read",
    "ContentNumberingTemplatesPage:Read",
    "ContentExportsPage:Read",
    "DriversPage:Read",
    "DriversFeedbacksPage:Read",
    "CompaniesPage:Read",
    "CompanyDriversPage:Read",
    "Payout:Read",
    "AssignationsPage:Read",
    "BillingInformationPage:Read",
    "Invoice:Read",
    "DriverProfilePage:Read",
    "DriverVehiclesPage:Read",
    "OrdersPage:Read",
    "CustomersPage:Read",
    "HostAgenciesPage:Read",
    "TravelAgentsPage:Read",
    "TravelAgentsPayoutsPage:Read",
    "ApiPartnersPage:Read",
    "PartnersPage:Read",
    "RidesPage:Read",
    "CreditLine:Read",
    "Numbering_Template:Read",
    "User:Read",
    "UserInvoicingData:Read",
    "OrdersPrices:Export",
    "Order:Read",
    "Orders:Read",
    "Drivers:Read",
    "DriversCompany:Read",
    "DriversCompanies:Read",
    "DriverBalance:Read",
    "DriverCustomerFeedback:Read",
    "DriverAssignations:Read",
    "CooperationAgreementSignPage:Read",
    "MangopayInformation:Read",
    "Payments:Read",
    "Unavailability:Read",
    "User_Driver:Update",
    "User_Driver_ShowInvoicingInfo:Update",
    "DriverVat:Validate",
    "MangopayInformation:Read",
    "BillingInformationPage:Read",
    "BillingInformation:Modify",
    "DriversCompany:Modify",
    "DriverDocument:Modify",
    "DriverDocument:Approve",
    "DriverVehicleDocument:Modify",
    "OrderClaims:Read",
    "Payments:Read",
    "Chargebacks:Read",
    "TravelAgents:Read",
    "Partners:Read",
    "ApiPartners:Read",
    "ApiPartners:Create",
    "ApiPartners:Update",
    "ApiPartners:Delete",
    "CommissionPayout:Create",
    "CommissionPayout:Approve",
    "CommissionPayout:RevertApproved",
    "CommissionPayout:Decline",
    "CommissionPayout:Read",
    "CommissionSettlements:Create",
    "CommissionSettlements:Read",
    "CommissionSettlements:Update",
    "DiscountCampaignsPage:Read",
    "DiscountCampaignPage:Create",
    "CommissionCampaignsPage:Read",
    "CommissionCampaignPage:Create",
];
const CUSTOMER_INTERFACE_PERMISSIONS = [
    "UserPassword_Myself:Modify",
    "Order_Myself:Create",
    "Order_Myself:Read",
    "Order_Myself:Update",
    "Order_Myself:Cancel",
    "Orders_Myself:Read",
    "CustomerInterface:Read",
    "Feedback_Myself:Read",
    "Feedback_Myself:Create",
    "Feedback_Myself:Update",
    "LatestDriverLocation:Read",
    "User_Myself:Read", // it is needed for retrieveUser, but is it safe to add it to customers?
    "Payment_Myself:Create",
];
const CUSTOMER_BOOKING_PROCESS_PERMISSIONS = [
    "Order_Myself:Read", // used as part of GetPoolDraftOrder
    "Orders_Myself:Read", // used as part of GetOrdersForConfirmationSummary on the "your booking is confirmed" page
    "Payment_Myself:Create", // needed for payment options other than cash one, e.g. createCardDirectPayIn
];
const CUSTOMER_TRIP_TRACKING_PERMISSIONS = ["LatestDriverLocation:Read", "Order_Myself:Read", "User_Myself:Read"];
const ROLES = {
    product: [],
    "user-role-manager": ["UserRoles:Full", "User:Create", "User:Update", "User:Delete", "InternalManagement:Access"],
    admin: ["User:Delete"],
    // generic role that allows users to log in to management portal
    "management-access": ["User_Myself:Read", "UserPassword_Myself:Modify"],
    "refund-master": ["RefundsPage:Read", "Chargeback:Create", "Payment:Fulfill"],
    "payout-master": [
        "Payout:Read",
        "Payout:Create",
        "Payout:Approve",
        "Payout:Send",
        "Payout:Fail",
        "Payout:Update",
        "Payout:Delete",
        "CreditLine:Modify",
        "CreditLine:Read",
        "Payment:Fulfill",
        "CommissionPayout:Create",
        "CommissionPayout:Approve",
        "CommissionPayout:RevertApproved",
        "CommissionPayout:Decline",
        "CommissionPayout:Read",
    ],
    "customer-support": [
        "OrdersPage:Read",
        "CustomersPage:Read",
        "HostAgenciesPage:Read",
        "TravelAgentsPage:Read",
        "TravelAgentsPayoutsPage:Read",
        "ApiPartnersPage:Read",
        "PartnersPage:Read",
        "ReferralCodesPage:Read",
        "OrdersAddressCheckPage:Read",
        "OrdersDepositCheckPage:Read",
        "CustomersFeedbacksPage:Read",
        "BlacklistedDepartureDatesPage:Read",
        "RidesPage:Read",
        "CooperationAgreementPage:Read",
        "ContentLocationsPage:Read",
        "ContentCountriesPage:Read",
        "ComboAssignationPage:Read",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "DriverVat:Validate",
        "InternalManagement:Access",
        "ReferralCode:Create",
        "User:Read",
        "User:Create",
        "User:Update",
        "User_Customer:Modify",
        "UserInvoicingData:Read",
        "Order:Create",
        "Order:Read",
        "Order:Update",
        "Order:Cancel",
        "Order:Confirm",
        "OrderAddress:Approve",
        "OrdersPrices:Export",
        "Orders:Read",
        "Assignation:Modify",
        "CompensationOverLimit:Modify",
        "Chargebacks:Read",
        "Chargeback_Cancelled:Create",
        "Chargeback_Surplus:Create",
        "Chargeback_ForNeverConfirmedOrder:Create",
        "Partners:Read",
        "Partners:Create",
        "Partners:Update",
        "Partners:Delete",
        "ApiPartners:Read",
        "ApiPartners:Create",
        "ApiPartners:Update",
        "ApiPartners:Delete",
        "CustomerInterfaceFromManagement:Read",
        "Feedback_Management:Create",
        "Fresh",
        "DynamicFormConfig:Read",
        "OrderClaims:Read",
        "AssignationOffersPage:Read",
        "AssignationOffer:Full",
        "CreditLine:Read",
        "VehicleModel:Read",
        "Vehicle:Create",
        "Vehicle:ReadAllowOld",
        "BlacklistedDepartureDates:Read",
        "DriversMapPage:Read",
        "DriversPage:Read",
        "CompaniesPage:Read",
        "CompanyDriversPage:Read",
        "DriversCompany:Read",
        "DriversCompanies:Read",
        "DriversCompany:Modify",
        "DriverVehicle:Update",
        "DriverVehicle:Approve",
        "DriverBalance:Read",
        "DriverCustomerFeedback:Read",
        "DriverDocument:Modify",
        "DriverVehicleDocument:Modify",
        "DriverDocument:Approve",
        "Drivers:Read",
        "DriverAssignations:Read",
        "DriversFeedbacksPage:Read",
        "MangopayInformation:Read",
        "Payment:Create",
        "PaymentRequest:Create",
        "Payments:Read",
        "Discount:Create",
        "DiscountCampaign:Modify",
        "DiscountCampaign:Read",
        "CommissionCampaign:Modify",
        "CommissionCampaign:Read",
        "Numbering_Template:Read",
        "TravelAgent:Modify",
        "TravelAgents:Read",
        "Location:Read",
        "Location:Create",
        "Location:Update",
        "Route:Read",
        "Route:Create",
        "Route:Update",
        "TripStatus:Read",
        "TripTracking:Read",
        "DriverTrackingLocations:Read",
        "EarlyOfferCredit:Read",
        "DriverFaq:ReadAll",
        "DriverTermsAndConditions:Read",
        "DriverTermsAndConditionsPage:Read",
        "DiscountCampaignsPage:Read",
        "CommissionCampaignsPage:Read",
    ],
    "driver-support": [
        "InternalManagement:Access",
        "ContentCountriesPage:Read",
        "ContentMapPage:Read",
        "ContentLocationsPage:Read",
        "CustomersPage:Read",
        "OrdersAddressCheckPage:Read",
        "OrdersDepositCheckPage:Read",
        "RidesPage:Read",
        "CustomerInterfaceFromManagement:Read",
        "AssignationOffersPage:Read",
        "AssignationOffer:Full",
        "ComboAssignationPage:Read",
        "OrderCombos:Read",
        "ComboAssignationOffer:Modify",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "PasswordResetPage:Read",
        "CooperationAgreementSignPage:Read",
        "User:Read",
        "User:Create",
        "User:Update",
        "UserInvoicingData:Read",
        "User_Driver:Create",
        "User_Driver:Update",
        "User_Driver_CanSpeakEnglish:Update",
        "User_Driver_ShowInvoicingInfo:Update",
        "Order:Read",
        "Order:Update",
        "OrdersPrices:Export",
        "Orders:Read",
        "CustomersFeedbacksPage:Read",
        "Assignation:Modify",
        "AssignationBid:Confirm",
        "Chargebacks:Read",
        "Payout:Read",
        "Payout:Create",
        "Payout_Pending:Fail",
        "Numbering_Template:Read",
        "Numbering_Template:Create",
        "Numbering_Template:Delete",
        "Invoice:Read",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "Feedback_Management:Create",
        "Unavailability:Read",
        "Unavailability:Update",
        "Fresh",
        "DynamicFormConfig:Read",
        "OrderClaims:Read",
        "DriverVat:Validate",
        "VehicleModel:Read",
        "Vehicle:Create",
        "Vehicle:ReadAllowOld",
        "Vehicle:ModifyAllowOld",
        "WillingToRent:Modify",
        "OrdersPage:Read",
        "DriversPage:Read",
        "CompaniesPage:Read",
        "CompanyDriversPage:Read",
        "DriversMapPage:Read",
        "DriversBalancePage:Read",
        "AssignationsPage:Read",
        "DocumentTypesPage:Read",
        "CooperationAgreementPage:Read",
        "CooperationAgreementReviewPage:Read",
        "DriverCountryRulesPage:Read",
        "DriversFeedbacksPage:Read",
        "MangopayInformation:Read",
        "BillingInformationPage:Read",
        "BillingInformation:Modify",
        "DriversCompany:Read",
        "DriversCompanies:Read",
        "DriversCompany:Modify",
        "DriverVehicle:Update",
        "DriverVehicle:Approve",
        "DriverBalance:Read",
        "DriverCustomerFeedback:Read",
        "DriverDocument:Modify",
        "DriverDocument:Approve",
        "DriverVehicleDocument:Modify",
        "Drivers:Read",
        "DriverAssignations:Read",
        "Payment:Create",
        "Payments:Read",
        "TripStatus:Read",
        "TripTracking:Read",
        "DriverTrackingLocations:Read",
        "CustomerFeedbacksForDriverPage:Read",
        "CustomerFeedbacksForDriversCompanyPage:Read",
        "EarlyOfferCredit:Read",
        "DriverFaq:ReadAll",
        "DriverTermsAndConditions:Read",
        "DriverTermsAndConditionsPage:Read",
        "DriverAssistant:Access",
        "DriverAssistant:ReadAll",
    ],
    "support-master": [
        "Order:Confirm",
        "Order:ConfirmWithoutValidation",
        "VehicleModel:Read",
        "VehicleModel:Modify",
        "WillingToRent:Modify",
        "SubsidyOverLimit:Modify",
        "CompensationOverLimit:Modify",
        "TripStatus:Read",
        "TripTracking:Read",
        "DriverTrackingLocations:Read",
        "DriversCompany:ActivateWithoutRequiredDocuments",
        "DriversCompany_ShareCustomerContactEarly:Modify",
        "Driver:ActivateWithoutRequiredDocuments",
        "Vehicle:ActivateWithoutRequiredDocuments",
        "DriverAssistant:Access",
        "DriverAssistant:ReadAll",
    ],
    "content-manager": [
        "ContentMapPage:Read",
        "ContentCountriesPage:Read",
        "ContentLocationsPage:Read",
        "ContentRoutesPage:Read",
        "ContentTagsPage:Read",
        "ContentTravelDataPage:Read",
        "ContentCurrenciesPage:Read",
        "ContentExportsPage:Read",
        "ContentNumberingTemplatesPage:Read",
        "ContentFlexibleOffersPage:Read",
        "User:Read",
        "InternalManagement:Access",
        "Country:Modify",
        "Location:Read",
        "Location:Create",
        "Location:Update",
        "Location:Delete",
        "Discount:Create",
        "Discount:Read",
        "Discount:Update",
        "Discount:Delete",
        "DiscountCampaign:Read",
        "DiscountCampaign:Modify",
        "DiscountCampaignsPage:Read",
        "DiscountCampaignPage:Create",
        "CommissionCampaign:Modify",
        "CommissionCampaign:Read",
        "CommissionCampaign:Read",
        "CommissionCampaign:Modify",
        "CommissionCampaignsPage:Read",
        "CommissionCampaignPage:Create",
        "Route:Create",
        "Route:Update",
        "Route:Delete",
        "Route:Read",
        "Numbering_Template:Read",
        "BlacklistedDepartureDates:Read",
        "BlacklistedDepartureDates:Modify",
        "Translation:Modify",
        "ApiPartners:Read", // needed on Route page
        "CrossBorderTripWhitelist:Modify",
        "CommissionPayout:Read",
        "Packages:Read",
        "FrequentlyAskedQuestionsPage:Read",
    ],
    "campaigns-manager": [],
    bizdev: [
        "ApiPartners:Create",
        "ApiPartners:Read",
        "ApiPartners:Update",
        "ApiPartners:Delete",
        "ApiPartnersPage:Read",
        "Chargebacks:Read", // needed on Order page
        "ContentCountriesPage:Read",
        "ContentLocationsPage:Read",
        "ContentMapPage:Read",
        "ContentRoutesPage:Read",
        "CreditLine:Read",
        "CustomersPage:Read",
        "Fresh",
        "HostAgenciesPage:Read",
        "InternalManagement:Access",
        "Location:Read",
        "MangopayInformation:Read",
        "Numbering_Template:Read", // needed on Country page
        "Order:Read",
        "OrderClaims:Read", // needed on Order page
        "Orders:Read",
        "OrdersPage:Read",
        "Partners:Create",
        "Partners:Read",
        "Partners:Update",
        "Partners:Delete",
        "PartnersPage:Read",
        "Payments:Read", // needed on Order page
        "ReferralCode:Create",
        "ReferralCodesPage:Read",
        "Route:Read",
        "TravelAgent:Delete",
        "TravelAgent:Modify",
        "TravelAgents:Read",
        "TravelAgentsPage:Read",
        "TravelAgentsPayoutsPage:Read",
        "User:Read",
        "User_Myself:Read",
        "DiscountCampaignsPage:Read",
        "CommissionCampaignsPage:Read",
    ],
    driver: [
        "Pin_Myself:Read",
        "Invoice_Myself:Read",
        "Unavailability_Myself:Read",
        "Unavailability_Myself:Update",
        "AssignationOffers_NearDriver:Read",
        "AssignationOffers_Personal:Read",
        "AssignationOffers_Personal:Accept",
        "AssignationOffers_Personal:Decline",
        "AssignationOffer:Read",
        "Assignation_Myself:Modify",
        "User_SelfCancelTrip:Modify",
        "AssignationsData_Myself:Read",
        "BillingInformationPage:Read",
        "BillingInformation_Myself:Modify",
        "BillingInformation_Myself:SetActive",
        "User_Driver_Myself:Read",
        "User_Driver_Myself:Update",
        "DriverDocument_Myself:Modify",
        "DriverBalance_Myself:Read",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "DriverVehicle_Myself:Update",
        "DriverVehicleDocument_Myself:Modify",
        "DriverVat:Validate",
        "Vehicle_Myself:Create",
        "PasswordResetPage:Read",
        "DriverFaq:Read",
        "CooperationAgreementSignPage:Read",
        "CooperationAgreement:Sign",
        "CustomerFeedbacksForDriverPage:Read",
        "UpcomingTripsPage:Read",
        "CompletedTripsPage:Read",
        "DeclinedAndCancelledTripsPage:Read",
        "ClaimOrderRequest_Myself:Create",
        "ClaimOrderRequest_Myself:Read",
        "DriverTermsAndConditions_Myself:Read",
        "DriverTermsAndConditions_Myself:Accept",
        "DriverFaq:ReadAll",
        "DriverAssistant:Access",
    ],
    "drivers-company": [
        "CompanyDriversPage:Read",
        "User_MyCompanyDriver:Read",
        "User_MyCompanyDriver:Create",
        "User_MyCompanyDriver:Update",
        "User_MyCompanyDriver:Delete",
        "Pin_Myself:Read",
        "Invoice_Myself:Read",
        "User:Create",
        "User_Driver_Company:Modify",
        "Unavailability_Myself:Read",
        "Unavailability_Myself:Update",
        "AssignationOffers_NearDriver:Read",
        "AssignationOffers_Personal:Read",
        "AssignationOffers_Personal:Accept",
        "AssignationOffers_Personal:Decline",
        "AssignationOffer:Read",
        "Assignation_Myself:Modify",
        "User_SelfCancelTrip:Modify",
        "AssignationsData_Myself:Read",
        "BillingInformationPage:Read",
        "BillingInformation_Myself:Modify",
        "BillingInformation_Myself:SetActive",
        "DriversCompany_Myself:Read",
        "DriversCompany_Myself:Modify",
        "User_Driver_Myself:Read",
        "User_Driver_Myself:Update",
        "DriverDocument_Myself:Modify",
        "DriverBalance_Myself:Read",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "DriverVehicle_Myself:Update",
        "DriverVehicleDocument_Myself:Modify",
        "DriverVat:Validate",
        "PasswordResetPage:Read",
        "Vehicle_Myself:Create",
        "DriverFaq:Read",
        "CooperationAgreementSignPage:Read",
        "CooperationAgreement:Sign",
        "CustomerFeedbacksForDriversCompanyPage:Read",
        "DriversCompanyUpcomingTrips:Page",
        "UpcomingTripsPage:Read",
        "CompletedTripsPage:Read",
        "DeclinedAndCancelledTripsPage:Read",
        "DriversCompanyDeclinedAndCancelledTripsPage:Read",
        "ClaimOrderRequest_Myself:Create",
        "ClaimOrderRequest_Myself:Read",
        "DriverTermsAndConditions_Myself:Read",
        "DriverTermsAndConditions_Myself:Accept",
        "DriverFaq:ReadAll",
        "DriverAssistant:Access",
    ],
    "drivers-company-driver": [
        "Pin_Myself:Read",
        "My_DriversCompany:Read",
        "UpcomingTripsPage:Read",
        "CompletedTripsPage:Read",
        "DeclinedAndCancelledTripsPage:Read",
        // TODO: check if we really need the company driver to have these permissions
        // been added as a result of removing userId authorization option #sc-32871
        "Assignation_Myself:Modify",
        "AssignationsData_Myself:Read",
        "User_Driver_Myself:Read",
        "DriverDocument_Myself:Modify",
        "DriverBalance_Myself:Read",
        "DriverProfilePage:Read",
        "DriverFaq:Read",
        "CustomerFeedbacksForDriverPage:Read",
        "DriverFaq:ReadAll",
        "DriverAssistant:Access",
        "DriverTermsAndConditions_Myself:Read",
    ],
    "regional-manager": REGIONAL_MANAGER_PERMISSIONS,
    "senior-regional-manager": [
        "OrdersPage:Read",
        "OrderInAssignedCountries:Read",
        "OrderInAssignedCountries:Update",
        "OrderClaims:Read",
        "Assignation:Modify",
        "AssignationOffer:Full",
        "Unavailability:Update",
        "Fresh",
        "VehicleModel:Read",
        "BlacklistedDepartureDatesPage:Read",
        "BlacklistedDepartureDates:Read",
        "Payments:Read",
        "Chargebacks:Read",
        "Numbering_Template:Read",
        "TripStatus:Read",
        ...REGIONAL_MANAGER_PERMISSIONS,
    ],
    "ca-master": [
        "DynamicFormConfig:Manage",
        "DriverTermsAndConditions:Read",
        "DriverTermsAndConditions:Modify",
        "DriverTermsAndConditionsPage:Read",
    ],
    "claiming-tool-subscription-master": [
        "OrderClaims:Read",
        "DriverRideBenefits:Modify",
        "CountryAssignationConfig:Read",
        "CountryAssignationConfig:Update",
        "EarlyOfferCredit:Read",
        "EarlyOfferCredit:Create",
        "EarlyOfferCredit:Deactivate",
    ],
    "pricing-master": ["CountryAssignationConfig:Read", "CountryAssignationConfig:Update"],
    finance: FINANCE_ROLE_PERMISSIONS,
    "finance-master": [
        ...FINANCE_ROLE_PERMISSIONS,
        "DocumentTypesPage:Read",
        "ReferralCodesPage:Read",
        "BlacklistedDepartureDatesPage:Read",
        "Country:Modify",
        "Currency:Modify",
        "Numbering_Template:Create",
        "Numbering_Template:Delete",
        "Invoice:Generate",
        "Invoice:CSVExport",
        "Invoice:Read",
        "Payout:Approve",
        "Payout:Send",
        "Payout:Create",
        "Payout:Fail",
        "Payout_Pending:Fail",
        "CreditLine:Modify",
        "ReferralCode:Create",
    ],
    "blacklisted-dates-api-integration": ["BlacklistedDepartureDates:Read", "BlacklistedDepartureDates:Modify"],
    // --- legacy site related roles ---
    "site-customer-customer-interface": CUSTOMER_INTERFACE_PERMISSIONS,
    "site-customer-booking-process": CUSTOMER_BOOKING_PROCESS_PERMISSIONS,
    "site-customer-trip-tracking": CUSTOMER_TRIP_TRACKING_PERMISSIONS,
    // --- new general customer roles ---
    customer: CUSTOMER_INTERFACE_PERMISSIONS,
    "customer-booking-process": CUSTOMER_BOOKING_PROCESS_PERMISSIONS,
    "customer-trip-tracking": CUSTOMER_TRIP_TRACKING_PERMISSIONS,
    // ----------------------------------
    "payment-request": ["User_Myself:Read", "Payment_Myself:Create"],
    "travel-agent": ["UserPassword_Myself:Modify"],
    "host-agency-admin": ["TravelAgents:Read"],
    "driver-faq-manager": ["DriverFaq:Update", "DriverFaq:ReadAll", "DriverAssistant_Knowledgebase:Write"],
    developer: ["BackgroundTask:Create"],
};
exports.ROLES = ROLES;
ROLES.admin = (0, uniq_1.default)([
    ...ROLES.admin,
    ...ROLES["customer-support"],
    ...ROLES["driver-support"],
    ...ROLES["content-manager"],
    ...ROLES["campaigns-manager"],
    ...ROLES["user-role-manager"],
    ...ROLES["payout-master"],
    ...ROLES["refund-master"],
    ...ROLES["support-master"],
    ...ROLES["ca-master"],
    ...ROLES["claiming-tool-subscription-master"],
    ...ROLES.finance,
    ...ROLES["finance-master"],
    ...ROLES["driver-faq-manager"],
    ...ROLES.developer,
]);
ROLES.product = (0, uniq_1.default)([
    ...ROLES.product,
    ...ROLES["customer-support"],
    ...ROLES["driver-support"],
    ...ROLES["content-manager"],
    ...ROLES["campaigns-manager"],
    ...ROLES["support-master"],
    ...ROLES["ca-master"],
    ...ROLES.finance,
    ...ROLES["finance-master"],
]);
//# sourceMappingURL=rolesWithPermissions.js.map